import { isAwaitingClientDecision, type JobOpportunity } from '../state/jobOpportunities'

/**
 * How the Job Detail "Decision" section behaves (MWA-406).
 *  - interactive: the section as it has always been, with its buttons.
 *  - readonly: one "Client decision: <decision>" line, no buttons or hint.
 *  - hidden: nothing to show.
 *
 * Once a job has a status the decision has been acted on, so offering the
 * buttons again is wrong (a decline pressed on an Applied job would archive
 * it). A job with no status is still awaiting the decision, or was declined and
 * archived, and a hidden opportunity has its own flow: both stay interactive.
 */
export type DecisionSectionMode = 'interactive' | 'readonly' | 'hidden'

export function decisionSectionMode(
  job: Pick<JobOpportunity, 'status' | 'hiddenOpportunity' | 'applyDecision'>
): DecisionSectionMode {
  if (job.hiddenOpportunity === true) return 'interactive'
  if (isAwaitingClientDecision(job)) return 'interactive'
  return job.applyDecision ? 'readonly' : 'hidden'
}
